import { Grid, Modal } from "@mui/material";
import React, { useState } from "react";
import {
  WorkPlanProps,
  WorkPlanContainer,
  KalenderIcon,
  AbfahrtIcon,
  Title,
  Info,
} from "../../utils/types";
import { ArbeitsplanDetailsModal } from "./ArbeitsplanDetailsModal";
import { Monteur } from "./Monteur";
import {
  getArbeitsplanTitle,
  getDateInfosList,
  getIsCurrentDateInRange,
} from "../../utils/helperFunctions";
import moment from "moment";
import { ArbeitsplanTitleWithUnderline } from "../../components/common/ArbeitsplanTitleWithUnderline";

export const KundendienstListItem: React.FC<WorkPlanProps> = ({
  workPlan,
  users,
}) => {
  const mitarbeiter = [
    ...new Set(workPlan.mitarbeiter?.split(",").map((x) => x?.trim())),
  ];
  const userList = users.filter((user) =>
    mitarbeiter.includes(String(user.mitarbeiternummer))
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const isCurrentDateInRange = getIsCurrentDateInRange(workPlan);
  const workPlanTitle = getArbeitsplanTitle(workPlan);

  return (
    <>
      <Grid item xs={12} md={6}>
        <WorkPlanContainer
          style={{
            outline: isCurrentDateInRange ? "3px solid #1d9538" : "none",
          }}
        >
          <div onClick={openModal}>
            <ArbeitsplanTitleWithUnderline title={workPlanTitle} />
            <Info>
              <div>
                <KalenderIcon />
                {moment(workPlan.datum, "YYYY-MM-DD").format("DD.MM.YYYY")}{" "}
                {workPlan.gesamttermindatumbis &&
                  workPlan.gesamttermindatumbis !=
                    workPlan.gesamttermindatumvon &&
                  ` - ${moment(workPlan.gesamttermindatumbis, "YYYY-MM-DD").format("DD.MM.YYYY")}`}
              </div>
              <div>
                <AbfahrtIcon />
                Abfahrt{" "}
                {workPlan.zeitvon.replace(new RegExp(":[0-9]*.0000000"), "")}
              </div>
              <Monteur userList={userList} />
            </Info>
          </div>
        </WorkPlanContainer>
      </Grid>
      <ArbeitsplanDetailsModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        workPlanList={[workPlan]}
        userList={userList}
      />
    </>
  );
};
